// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__9NzUA","left":"InfoRow_left__WpS93"};